import React from 'react'
import { useTheme } from '../../../../Utils/useTheme'

export const TableRoot = ({ children }: any) => {
  const { border } = useTheme()

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        borderRadius: 18,
        overflow: 'hidden',
        border: `1px solid ${border}`,
        display: 'flex',
        flexDirection: 'column',
        background: 'rgba(255,255,255,0.92)',
        boxShadow: 'rgba(17, 24, 39, 0.08) 0px 14px 36px'
      }}
    >
      {children}
    </div>
  )
}
